import React from 'react';

import { Radio } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { RadioChecked, RadioUnchecked } from '../../icons';

export interface RadioButtonProps {
  checked?: boolean;
  className?: string;
  disabled?: boolean;
  label?: React.ReactNode;
  onChange?: (e?: any) => void;
  testId?: string;
  value?: string | number;
}

const useStyles = makeStyles((theme: Theme) => ({
  radioButton: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-start',
    '& svg': {
      color: theme.palette.common.black,
    },
  },

  fullWidth: {
    width: '100%',

    '& .MuiFormControlLabel-label': {
      width: '100%',
    },
  },
}));

export function RadioButton(props: RadioButtonProps): JSX.Element {
  const {
    checked,
    className = '',
    disabled,
    label = '',
    onChange,
    testId,
    value,
    ...rest
  } = props;

  const classes = useStyles();

  const formControlLabelStyle = clsx(
    classes.radioButton,
    label && classes.fullWidth,
    className || '',
  );

  return (
    <FormControlLabel
      className={formControlLabelStyle}
      control={
        <Radio
          checked={checked}
          checkedIcon={<RadioChecked size="s" />}
          color="default"
          disabled={disabled}
          icon={<RadioUnchecked size="s" />}
          inputProps={{
            'aria-checked': checked,
          }}
          tabIndex={0}
          value={value}
        />
      }
      data-fd={testId}
      label={label}
      labelPlacement="end"
      onChange={onChange}
      value={value}
      {...rest}
    />
  );
}
